/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import orderBy from 'lodash/orderBy';
import {
  Card,
  CardTitle,
  CardHeader,
  CardText,
} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';
import CircularProgress from 'material-ui/CircularProgress';
import { database } from '../../utils/configureFirebase';
import csvConverter from '../../utils/CandidateCSV';
import { theme } from '../../utils/getTheme';

const myanatomy = 'MA#CSV#PASSWORD';
const ContentContainer = styled.div`
    padding: 0 16px;

  & > * + * {
    margin-top: 32px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: wrap;
  justify-content: space-between;
  width: 100%;
  & > * + * {
    widht: 40%;
  }
`;

const LoaderWrapper = styled.div`
  text-align: center;
`;

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const CountWrapper = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  align-items: center;

  & > * + * {
    margin-right: 8px;
  }
`;

const CountText = styled.div`
  margin-right: 8px;
`;

const CountContainer = styled.div`
  background: ${props => props.theme.accent1Color};
  color: white;
  border-radius: 24px;
  text-align: center;
  height: 40px;
  width: 40px;
  padding-top: 8px;
  font-size: 22px;
`;

const DateContainer = styled.div`
  padding-top: 16px;
  font-weight: 600;
  font-size: 15px;
`;

class EarlyBirdCandidate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      college: undefined,
      registerations: undefined,
      isLoading: true,
      csvConfirmationModal: false,
      password: '',
      passwordErrorText: undefined,
    };
  }

  componentDidMount() {
    const { match } = this.props;

    this.collegeRef = database.ref(`contact/college/${match.params.id}`);
    this.collegeRef.on('value', this.setCollegeRegistrationData);

    this.registrationRef = database.ref(`contact/candidate/${match.params.id}`);
    this.registrationRef.on('value', this.setRegistrationData);
  }

  componentWillUnmount() {
    this.registrationRef.off('value', this.setRegistrationData);
  }

  setRegistrationData = (snapshot) => {
    if (snapshot) {
      const registrations = snapshot.val();
      this.setState({
        registrations,
        isLoading: false,
      });
    }
  }

  setCollegeRegistrationData = (snapshot) => {
    if (snapshot) {
      const college = snapshot.val();
      this.setState({
        college,
      });
    }
  }

  getRegistrations = (registrations) => {
    if (typeof registrations !== 'undefined' && registrations !== null) {
      const studentsArr = Object.keys(registrations)
        .map((candidateId) => {
          const formattedData = this.formatRegistration(registrations[candidateId]);
          return {
            ...formattedData,
            candidateId,
          };
        });
      return orderBy(studentsArr, student => student.timestamp, 'asc');
    }

    return [];
  }

  formatRegistration = data => ({ // eslint-disable-line
    ...data,
    // dob: formatDate(data.dob),
    certifications: data.certifications === '' ? '-' : data.certifications,
  });

  formattedDate = (timestamp) => {
    const date = new Date(timestamp);
    return `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}-${date.getHours()}:${date.getMinutes()}`;
  }

  openCSVConfirmationModal = () => {
    this.setState(() => ({
      csvConfirmationModal: true,
      passwordErrorText: undefined,
      password: '',
    }));
  }

  closeCSVConfirmationModal = () => {
    this.setState(() => ({
      csvConfirmationModal: false,
    }));
  }

  downloadCSV = (candidateRegistrations, collegeName) => {
    const { password } = this.state;

    if (password === myanatomy) {
      csvConverter(candidateRegistrations, `EB-${collegeName}`);
      this.setState(() => ({
        csvConfirmationModal: false,
      }));
    } else {
      this.setState(() => ({
        passwordErrorText: 'PasswordMismatch',
      }));
    }
  }

  getPlacements = (registerations) => {
    const placed = registerations.map(regs => regs.placementStatus);
    const placedCount = placed.reduce((count, currentVal) => {
      if (typeof count[currentVal] !== 'undefined') {
        count[currentVal] += 1;
        return count;
      }
      count[currentVal] = 1;
      return count;
    }, {});

    return placedCount;
  }

  getStreams = (registerations) => {
    const streams = registerations.map(regs => regs.stream);
    const streamsCount = streams.reduce((count, currentVal) => {
      if (typeof count[currentVal] !== 'undefined') {
        count[currentVal] += 1;
        return count;
      }
      count[currentVal] = 1;
      return count;
    }, {});

    return streamsCount;
  }

  getDegrees = (registerations) => {
    const degrees = registerations.map(regs => regs.degree);
    const degreesCount = degrees.reduce((count, currentVal) => {
      if (typeof count[currentVal] !== 'undefined') {
        count[currentVal] += 1;
        return count;
      }
      count[currentVal] = 1;
      return count;
    }, {});

    return degreesCount;
  }

  getGenderDiversity = (registerations) => {
    const genders = registerations.map(regs => regs.gender);
    const gendersCount = genders.reduce((count, currentVal) => {
      if (typeof count[currentVal] !== 'undefined') {
        count[currentVal] += 1;
        return count;
      }
      count[currentVal] = 1;
      return count;
    }, {});

    return gendersCount;
  }

  getFormattedDate = (date) => {
    const dateObj = new Date(date);
    const month = (dateObj.getMonth()) + 1;
    const day = (dateObj.getDate());
    const year = dateObj.getFullYear();
    const driveProcessDate = `${day}-${month}-${year}`;
    return driveProcessDate;
  };

  render() {
    const {
      registrations,
      isLoading,
      college,
    } = this.state;
    const candidateRegistrations = this.getRegistrations(registrations);
    const placements = this.getPlacements(candidateRegistrations);
    const streams = this.getStreams(candidateRegistrations);
    const degrees = this.getDegrees(candidateRegistrations);
    const genders = this.getGenderDiversity(candidateRegistrations);
    return (
      <div>
        {isLoading ? (
          <ContentContainer>
            <LoaderWrapper>
              <CircularProgress />
            </LoaderWrapper>
          </ContentContainer>
        ) : (
            <ContentContainer>
              <Card>
                <CardTitle
                  title={college.collegeName}
                  subtitle={`${college.collegeYear} | ${college.university} | ${college.society}`}
                />
                <CardText style={{ paddingTop: 0 }}>
                  <ContentWrapper>
                    <div><CardHeader title="Address" style={{ paddingLeft: 0 }} />
                      {`${college.address}, ${college.city}, ${college.state}`}
                    </div>
                    <DateContainer>
                      Registration Date: {this.getFormattedDate(college.timestamp)}
                    </DateContainer>
                  </ContentWrapper>
                </CardText>
              </Card>
              {candidateRegistrations.length > 0 ? (
                <Card style={{ position: 'relative' }}>
                  <CountWrapper>
                    <CountText>
                      <b>Total Registreations</b>
                    </CountText>
                    <CountContainer>
                      {candidateRegistrations.length}
                    </CountContainer>
                  </CountWrapper>
                  <CardText>
                    <CardTitle
                      title="Demographics"
                      subtitle="Registreation details as per the following parameters"
                      style={{ paddingLeft: 0, paddingTop: 0 }}
                    />
                    <CardHeader title="Streams" style={{ paddingLeft: 0 }} />
                    <ChipContainer>
                      {Object.keys(streams).map((streamId) => {
                        const stream = streams[streamId];
                        return (
                          <Chip
                            key={streamId}
                            style={{
                              marginBottom: 8,
                              marginRight: 8,
                            }}
                          >
                            <Avatar
                              backgroundColor={theme.primary1Color}
                            >
                              {stream}
                            </Avatar>
                            {streamId}
                          </Chip>
                        );
                      })}
                    </ChipContainer>

                    <CardHeader title="Degrees" style={{ paddingLeft: 0 }} />
                    <ChipContainer>
                      {Object.keys(degrees).map((degreeId) => {
                        const degree = degrees[degreeId];
                        return (
                          <Chip
                            key={degreeId}
                            style={{
                              marginBottom: 8,
                              marginRight: 8,
                            }}
                          >
                            <Avatar
                              backgroundColor={theme.primary1Color}
                            >
                              {degree}
                            </Avatar>
                            {degreeId}
                          </Chip>
                        );
                      })}
                    </ChipContainer>

                    <CardHeader title="Placement Status" style={{ paddingLeft: 0 }} />
                    <ChipContainer>
                      {Object.keys(placements).map((placeId) => {
                        const placed = placements[placeId];
                        return (
                          <Chip
                            key={placeId}
                            style={{
                              marginBottom: 8,
                              marginRight: 8,
                            }}
                          >
                            <Avatar
                              backgroundColor={theme.primary1Color}
                            >
                              {placed}
                            </Avatar>
                            {placeId}
                          </Chip>
                        );
                      })}
                    </ChipContainer>

                    <CardHeader title="Gender Diversity" style={{ paddingLeft: 0 }} />
                    <ChipContainer>
                      {Object.keys(genders).map((genderId) => {
                        const gender = genders[genderId];
                        return (
                          <Chip
                            key={genderId}
                            style={{
                              marginBottom: 8,
                              marginRight: 8,
                            }}
                          >
                            <Avatar
                              backgroundColor={theme.primary1Color}
                            >
                              {gender}
                            </Avatar>
                            {genderId}
                          </Chip>
                        );
                      })}
                    </ChipContainer>
                  </CardText>
                </Card>
              ) : null}
            </ContentContainer>
          )}
      </div>
    );
  }
}

EarlyBirdCandidate.propTypes = {
  match: PropTypes.object.isRequired, // eslint-disable-line
  history: PropTypes.object.isRequired, // eslint-disable-line
};

export default EarlyBirdCandidate;



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCandidate/EarlyBirdCandidate.js